import React from "react";
import "../CustomCSS/Features.css";
import { FaPhoneAlt, FaCalendarCheck, FaUserMd, FaMicroscope } from "react-icons/fa";

const Features = () => {
  const features = [
    {
      icon: <FaPhoneAlt />,
      title: "24/7 Emergency Support",
      description:
        "Immediate medical help available round-the-clock with rapid response to urgent situations.",
    },
    {
      icon: <FaCalendarCheck />,
      title: "Hassle-Free Booking",
      description:
        "Quick and easy appointment scheduling system tailored for patient convenience.",
    },
    {
      icon: <FaUserMd />,
      title: "Trusted Medical Experts",
      description:
        "Experienced doctors and healthcare professionals ensuring reliable and quality treatment.",
    },
    {
      icon: <FaMicroscope />,
      title: "Modern Diagnostic Tools",
      description:
        "Equipped with advanced technology for accurate diagnosis and effective treatment.",
    },
  ];

  return (
    <section id="features" className="features-section">
      <h2 className="features-title">Our Features</h2>
      <div className="features-grid">
        {features.map((item, index) => (
          <div className="feature-card" key={index}>
            <div className="feature-icon">{item.icon}</div>
            <h3 className="feature-title">{item.title}</h3>
            <p className="feature-text">{item.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Features;
